import { gql } from '@apollo/client';

export const PROPOSAL = gql`
  query Proposal($id: ID!) {
    proposal(id: $id) {
      id
      orderId
      contractorId
      userId
      siteVisitId
      planId
      mapResultId
      mapResult {
        id
        snapshot
        map
      }
      plan {
        id
        title
        meta
        planSVG
        planId
        photos
      }
      contractor {
        id
        name
      }
      price
      currency
      comment
      timeline {
        from
        to
        unit
      }
      estimate {
        total
      }
      formPayload
      executionTimeframe
      validUntil
      payload
      notes
      status
      type
      createdAt
      updatedAt
    }
  }
`;

export const ORDER_PROPOSALS = gql`
  query OrderProposals($orderId: ID!) {
    orderProposals(orderId: $orderId) {
      id
      orderId
      contractorId
      userId
      siteVisitId
      planId
      mapResultId
      mapResult {
        id
        snapshot
        map
      }
      contractor {
        id
        name
      }
      price
      currency
      comment
      timeline {
        from
        to
        unit
      }
      estimate {
        total
      }
      formPayload
      executionTimeframe
      validUntil
      payload
      notes
      status
      type
      createdAt
      updatedAt
    }
  }
`;

export const MY_PROPOSALS = gql`
  query MyProposals($page: Int, $pageSize: Int) {
    myProposals(page: $page, pageSize: $pageSize) {
      items {
        id
        orderId
        contractorId
        userId
        siteVisitId
        planId
        mapResultId
        mapResult {
          id
          snapshot
          map
        }
        price
        currency
        comment
        timeline {
          from
          to
          unit
        }
        estimate {
          total
        }
        formPayload
        executionTimeframe
        validUntil
        payload
        notes
        status
        type
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

export const PROPOSALS = gql`
  query Proposals($page: Int, $pageSize: Int) {
    proposals(page: $page, pageSize: $pageSize) {
      items {
        id
        orderId
        contractorId
        contractor {
          id
          name
        }
        userId
        user {
          id
          name
          email
        }
        siteVisitId
        planId
        mapResultId
        mapResult {
          id
          snapshot
          map
        }
        price
        currency
        comment
        timeline {
          from
          to
          unit
        }
        estimate {
          total
        }
        formPayload
        executionTimeframe
        validUntil
        payload
        notes
        status
        type
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;
